export const shopifyAuth = {
    _id: 'string',
};

export const shopifyAuthLink = {
    url: 'string',
};

export const tiendNubeAuthLink = {
    url: 'string',
};
